// Madesa AJAX Filters and Collection Controls
(function() {
  const filterTrigger = document.querySelector('.madesa-filter-trigger');
  const mobileFilterBtn = document.querySelector('.mobile-filter-btn');
  const filterDrawer = document.querySelector('.madesa-filter-drawer');
  const filterCloseBtn = document.querySelector('.filter-close-btn');
  const filterOverlay = document.querySelector('.filter-drawer-overlay');
  const filterForm = document.getElementById('madesa-filter-form');
  const clearFiltersBtn = document.getElementById('clear-filters-btn');
  const productList = document.getElementById('madesa-product-list');
  const pagination = document.getElementById('madesa-pagination');

  // Sort modal elements
  const mobileSortBtn = document.querySelector('.mobile-sort-btn');
  const sortModal = document.getElementById('madesa-sort-modal');
  const sortModalClose = document.querySelector('.sort-modal-close');
  const sortModalOverlay = document.querySelector('.sort-modal-overlay');
  const sortModalRadios = document.querySelectorAll('input[name="sort_by_modal"]');

  if (!filterDrawer || !filterForm) return;

  // Get section ID from the results-list element
  const resultsListElement = document.querySelector('results-list[section-id]');
  const sectionId = resultsListElement?.getAttribute('section-id');

  function getRenderedSectionRoot(fragment) {
    if (!fragment || !sectionId) return fragment;
    const raw = String(sectionId).replace(/^shopify-section-/, '');
    const esc =
      typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
        ? CSS.escape(raw)
        : raw.replace(/([^\w-])/g, '\\$1');
    const wrapped = fragment.querySelector('#shopify-section-' + esc);
    return wrapped || fragment;
  }

  // Check if desktop (filters always visible)
  function isDesktop() {
    return window.innerWidth >= 750;
  }

  // Drawer controls
  function openDrawer() {
    if (isDesktop()) return; // Don't toggle on desktop
    filterDrawer.setAttribute('aria-hidden', 'false');
    if (filterTrigger) filterTrigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (isDesktop()) return; // Don't toggle on desktop
    filterDrawer.setAttribute('aria-hidden', 'true');
    if (filterTrigger) filterTrigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  // Initialize drawer state based on viewport
  function initDrawerState() {
    if (isDesktop()) {
      filterDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = '';
    } else {
      filterDrawer.setAttribute('aria-hidden', 'true');
    }
  }

  // Initialize on load
  initDrawerState();

  // Re-initialize on resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initDrawerState, 250);
  });

  // Filter drawer controls
  filterTrigger?.addEventListener('click', openDrawer);
  mobileFilterBtn?.addEventListener('click', openDrawer);
  filterCloseBtn?.addEventListener('click', closeDrawer);
  filterOverlay?.addEventListener('click', closeDrawer);

  // Sort modal controls
  function openSortModal() {
    if (sortModal) {
      sortModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeSortModal() {
    if (sortModal) {
      sortModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  mobileSortBtn?.addEventListener('click', openSortModal);
  sortModalClose?.addEventListener('click', closeSortModal);
  sortModalOverlay?.addEventListener('click', closeSortModal);

  // Handle sort selection in modal
  sortModalRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      if (radio.checked) {
        const sortValue = radio.value;
        
        // Update desktop select if exists
        const desktopSelect = document.getElementById('madesa-sort-select');
        if (desktopSelect) {
          desktopSelect.value = sortValue;
        }
        
        syncMadesaManualRangeInputs(filterForm);
        const filterParams = getFormData();
        
        // Build URL with both filters and sort
        const url = new URL(window.location.href);
        url.search = ''; // Clear existing params
        
        // Add filter params
        if (filterParams) {
          const params = new URLSearchParams(filterParams);
          params.forEach((value, key) => {
            url.searchParams.append(key, value);
          });
        }
        
        // Add sort param
        url.searchParams.set('sort_by', sortValue);
        
        // Apply with combined parameters
        applyFilters(url.search);
        
        // Close modal
        closeSortModal();
      }
    });
  });

  // Close on Escape key (mobile only)
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (!isDesktop() && filterDrawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
      if (sortModal && sortModal.getAttribute('aria-hidden') === 'false') {
        closeSortModal();
      }
    }
  });

  // AJAX Filter functionality
  let debounceTimers = {};
  
  function debounce(func, delay, key = 'default') {
    clearTimeout(debounceTimers[key]);
    debounceTimers[key] = setTimeout(func, delay);
  }

  function restorePriceRangeInputNames(form) {
    if (!form) return;
    form.querySelectorAll('price-range').forEach((el) => {
      if (typeof el.restorePriceRangeInputNames === 'function') {
        el.restorePriceRangeInputNames();
      }
    });
  }

  function getFormData() {
    const formData = new FormData(filterForm);
    const params = new URLSearchParams();
    
    for (const [key, value] of formData.entries()) {
      if (value) {
        params.append(key, value);
      }
    }
    
    const q = params.toString();
    restorePriceRangeInputNames(filterForm);
    return q;
  }

  function syncMadesaManualRangeInputs(form) {
    if (!form) return;
    form.querySelectorAll('price-range').forEach((el) => {
      if (typeof el.applyManualValuesBeforeSubmit === 'function') {
        el.applyManualValuesBeforeSubmit();
      }
      if (typeof el.suppressFullRangePriceParams === 'function') {
        el.suppressFullRangePriceParams();
      }
    });
    form.querySelectorAll('list-range').forEach((el) => {
      if (typeof el.applyManualValuesBeforeSubmit === 'function') {
        el.applyManualValuesBeforeSubmit();
      }
    });
  }

  function updateURL(params) {
    const baseUrl = filterForm.dataset.collectionUrl;
    const newUrl = params ? `${baseUrl}?${params}` : baseUrl;
    window.history.pushState({ path: newUrl }, '', newUrl);
  }

  function showLoading() {
    const applyBtn = filterForm.querySelector('.filter-footer-apply');
    const applyText = applyBtn?.querySelector('.filter-apply-text');
    const loadingIcon = applyBtn?.querySelector('.filter-loading');
    
    if (applyText) applyText.style.display = 'none';
    if (loadingIcon) loadingIcon.style.display = 'inline-block';
    if (applyBtn) applyBtn.disabled = true;
    
    if (productList) {
      productList.style.opacity = '0.5';
      productList.style.pointerEvents = 'none';
    }
  }

  function hideLoading() {
    const applyBtn = filterForm.querySelector('.filter-footer-apply');
    const applyText = applyBtn?.querySelector('.filter-apply-text');
    const loadingIcon = applyBtn?.querySelector('.filter-loading');
    
    if (applyText) applyText.style.display = 'inline';
    if (loadingIcon) loadingIcon.style.display = 'none';
    if (applyBtn) applyBtn.disabled = false;
    
    if (productList) {
      productList.style.opacity = '1';
      productList.style.pointerEvents = 'all';
    }
  }

  async function applyFilters(customParams = null) {
    syncMadesaManualRangeInputs(filterForm);
    showLoading();
    
    const params = customParams || getFormData();
    if (customParams) {
      restorePriceRangeInputNames(filterForm);
    }
    const baseUrl = filterForm.dataset.collectionUrl;
    let url;
    
    if (customParams) {
      // customParams already includes '?' prefix
      url = `${baseUrl}${params}&section_id=${sectionId}`;
    } else {
      // getFormData() returns params without '?' prefix
      url = params ? `${baseUrl}?${params}&section_id=${sectionId}` : `${baseUrl}?section_id=${sectionId}`;
    }

    try {
      const response = await fetch(url);
      const html = await response.text();
      
      // Create temporary container to parse response
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const sectionRoot = getRenderedSectionRoot(tempDiv);

      // Update active filters section
      const activeFiltersContainer = document.getElementById('madesa-active-filters');
      const newActiveFilters = sectionRoot.querySelector('#madesa-active-filters');
      
      if (activeFiltersContainer) {
        if (newActiveFilters) {
          // Server returned updated active filters
          activeFiltersContainer.innerHTML = newActiveFilters.innerHTML;
        } else {
          // Server didn't return active filters (first selection), build it manually
          const checkboxes = filterForm.querySelectorAll('input[type="checkbox"]:checked');
          const priceInputs = filterForm.querySelectorAll('.filter-price-input');
          const hasFilters = checkboxes.length > 0 || Array.from(priceInputs).some(input => input.value);
          
          if (hasFilters) {
            // Build active filters HTML
            let activeFiltersHTML = '<div class="filter-active-section">';
            activeFiltersHTML += '<h5 class="filter-active-title">Filtros ativos</h5>';
            activeFiltersHTML += '<div class="filter-active-list">';
            
            // Add checkbox filters
            checkboxes.forEach(checkbox => {
              const label = checkbox.closest('.filter-item')?.querySelector('.filter-label')?.textContent || checkbox.value;
              const filterGroup = checkbox.closest('.filter-group')?.querySelector('.filter-group-title')?.textContent || '';
              activeFiltersHTML += `
                <button type="button" class="filter-active-tag" data-filter-value="${checkbox.value}">
                  <span>${filterGroup}: ${label}</span>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M12 4L4 12M4 4L12 12" stroke="#A4ADA8" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </button>
              `;
            });
            
            const clearHref =
              filterForm.dataset.searchClearUrl || filterForm.dataset.collectionUrl || '';
            activeFiltersHTML +=
              '<a href="' + clearHref + '" class="filter-clear-all">Limpar tudo</a>';
            activeFiltersHTML += '</div></div>';
            
            activeFiltersContainer.innerHTML = activeFiltersHTML;
            
            // Add event listeners to remove individual filters
            activeFiltersContainer.querySelectorAll('.filter-active-tag').forEach(tag => {
              tag.addEventListener('click', () => {
                const filterValue = tag.dataset.filterValue;
                const checkbox = filterForm.querySelector(`input[value="${filterValue}"]`);
                if (checkbox) {
                  checkbox.checked = false;
                  applyFilters();
                }
              });
            });
          } else {
            activeFiltersContainer.innerHTML = '';
          }
        }
      }
      
      // Update filter header badge
      const filterHeaderBadge = document.querySelector('.filter-header-content .filter-count-badge');
      const newFilterHeader = sectionRoot.querySelector('.filter-header-content');
      const newHeaderBadge = newFilterHeader?.querySelector('.filter-count-badge');
      if (filterHeaderBadge && newHeaderBadge) {
        filterHeaderBadge.textContent = newHeaderBadge.textContent;
        filterHeaderBadge.style.display = 'flex';
      } else if (filterHeaderBadge && !newHeaderBadge) {
        filterHeaderBadge.style.display = 'none';
      } else if (!filterHeaderBadge && newHeaderBadge) {
        // Add badge if it doesn't exist
        const headerContent = document.querySelector('.filter-header-content');
        if (headerContent) {
          const badge = document.createElement('span');
          badge.className = 'filter-count-badge';
          badge.textContent = newHeaderBadge.textContent;
          headerContent.appendChild(badge);
        }
      }

      const newTriggerBadge = sectionRoot.querySelector('.madesa-filter-trigger .filter-count-badge');
      const triggerBadge = document.querySelector('.madesa-filter-trigger .filter-count-badge');
      if (triggerBadge) {
        if (newTriggerBadge) {
          triggerBadge.textContent = newTriggerBadge.textContent;
          triggerBadge.style.display = '';
        } else {
          triggerBadge.style.display = 'none';
        }
      }
      
      // Update product list
      const newProductList = sectionRoot.querySelector('#madesa-product-list');
      if (newProductList && productList) {
        productList.innerHTML = newProductList.innerHTML;
        if (productList.closest('.madesa-search-results')) {
          productList.dispatchEvent(new CustomEvent('madesa:search-list-refresh', { bubbles: false }));
        }
      }
      
      // Update pagination
      const newPagination = sectionRoot.querySelector('#madesa-pagination');
      if (pagination) {
        if (newPagination) {
          pagination.innerHTML = newPagination.innerHTML;
          pagination.style.display = '';
        } else {
          pagination.style.display = 'none';
        }
      }
      
      // Update URL
      if (customParams) {
        window.history.pushState({}, '', baseUrl + customParams);
      } else {
        updateURL(params);
      }
      
      // Contador vem do HTML da section (total_active_filters). Não chamar updateFilterCount()
      // aqui — ele somava todos os checkboxes, inclusive os ocultos do list-range (ex.: 187).
      
      // Scroll to top of product list
      productList?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      
    } catch (error) {
      console.error('Error applying filters:', error);
    } finally {
      hideLoading();
    }
  }

  function updateFilterCount() {
    let count = 0;
    filterForm.querySelectorAll('input[type="checkbox"]:checked').forEach((cb) => {
      if (cb.closest('.list-range-hidden-values')) return;
      count++;
    });

    filterForm.querySelectorAll('list-range').forEach((lr) => {
      const minR = lr.querySelector('#range-min');
      const maxR = lr.querySelector('#range-max');
      if (!minR || !maxR) return;
      const minV = parseInt(minR.value, 10);
      const maxV = parseInt(maxR.value, 10);
      const lo = parseInt(minR.getAttribute('min') || '0', 10);
      const hi = parseInt(maxR.getAttribute('max') || '0', 10);
      if (minV > lo || maxV < hi) {
        count++;
      }
    });

    const priceInputs = filterForm.querySelectorAll('.filter-price-input');
    const hasPriceFilter = Array.from(priceInputs).some((input) => input.value);
    if (hasPriceFilter) count++;
    
    // Update badges
    const badges = document.querySelectorAll('.filter-count-badge');
    badges.forEach(badge => {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
    
    // Update apply button text
    const applyText = filterForm.querySelector('.filter-apply-text');
    if (applyText) {
      applyText.textContent = 'Aplicar filtros';
    }
  }

  // Form submission
  filterForm.addEventListener('submit', (e) => {
    e.preventDefault();
    applyFilters();
    if (!isDesktop()) {
      closeDrawer();
    }
  });

  // Auto-apply on checkbox change (desktop only)
  filterForm.addEventListener('change', (e) => {
    if (e.target.classList.contains('filter-input') && e.target.type === 'checkbox') {
      updateFilterCount();
      // Auto-submit on checkbox change for desktop
      if (isDesktop()) {
        debounce(() => {
          applyFilters();
        }, 300, 'checkbox');
      }
    }
  });

  // Auto-apply on price input change
  const priceInputs = filterForm.querySelectorAll('.filter-price-input');
  priceInputs.forEach((input, index) => {
    input.addEventListener('input', () => {
      updateFilterCount();
      if (isDesktop()) {
        debounce(() => {
          applyFilters();
        }, 800, 'price');
      }
    });
  });

  // Clear filters
  clearFiltersBtn?.addEventListener('click', () => {
    // Uncheck all checkboxes
    const checkboxes = filterForm.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(cb => cb.checked = false);
    
    // Clear price inputs
    const priceInputs = filterForm.querySelectorAll('.filter-price-input');
    priceInputs.forEach(input => input.value = '');
    
    // Apply cleared filters
    applyFilters();
    updateFilterCount();
  });

  // Handle active filter tag removals
  document.addEventListener('click', (e) => {
    if (e.target.closest('.filter-active-tag')) {
      e.preventDefault();
      const link = e.target.closest('.filter-active-tag');
      
      // Find and uncheck the corresponding checkbox
      const href = link.getAttribute('href');
      if (href) {
        window.location.href = href; // For now, use direct navigation
      }
    }
  });

  // Initialize filter count on page load
  updateFilterCount();

  // Sort functionality
  const sortSelect = document.getElementById('madesa-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const sortValue = sortSelect.value;
      
      syncMadesaManualRangeInputs(filterForm);
      const filterParams = getFormData();
      
      // Build URL with both filters and sort
      const url = new URL(window.location.href);
      url.search = ''; // Clear existing params
      
      // Add filter params
      if (filterParams) {
        const params = new URLSearchParams(filterParams);
        params.forEach((value, key) => {
          url.searchParams.append(key, value);
        });
      }
      
      // Add sort param
      url.searchParams.set('sort_by', sortValue);
      
      // Apply with combined parameters
      applyFilters(url.search);
    });
  }
})();
